/**
 * @file SEO.jsx
 *
 * Reusable component for dynamic <head> meta tags using react-helmet-async.
 * Sets page title, description, Open Graph, and Twitter Card tags.
 *
 * Usage:
 *   <SEO title="Dr. García — Cardiología | Consultto" description="..." />
 */
import React from "react";
import { Helmet } from "react-helmet-async";
import { SEO_STRINGS } from "../constants/strings";

const SEO = ({ title, description, ogImage, ogUrl, ogType = "website" }) => {
  const pageTitle = title || SEO_STRINGS.DEFAULT_TITLE;
  const pageDescription = description || SEO_STRINGS.DEFAULT_DESCRIPTION;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />

      {/* Open Graph */}
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content={SEO_STRINGS.SITE_NAME} />
      {ogUrl && <meta property="og:url" content={ogUrl} />}
      {ogImage && <meta property="og:image" content={ogImage} />}

      {/* Twitter Card */}
      <meta name="twitter:card" content={ogImage ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}
    </Helmet>
  );
};

export default SEO;
